import * as ko from "knockout"
import {FormValidator} from "./FormValidator";
import {ErrorObject} from "../../../error/ErrorObject";
import {IPasswordPolicy} from "../../../index";
import {nsResetPassword} from "../nsResetPassword";
import formHtml from './form.html?raw';

export const template: string = formHtml;

interface IParams {
    observableInputs: IObservableInputs
    formValidator: FormValidator
    onSubmitClick: Function
    passwordpolicy: IPasswordPolicy
    isGenerating: KnockoutObservable<boolean>
    mode: TPasswordPageMode
    /** When false, hide the form submit button (e.g. dialog footer owns Continue). Default true. */
    showSubmitButton?: boolean
}

export class viewModel {
    private readonly observableInputs: IObservableInputs;
    private readonly formValidator: FormValidator
    private readonly states: IGetCssStates
    private readonly errObj_isSame!: ErrorObject
    private readonly hasHadFocus_old: KnockoutObservable<boolean> = ko.observable(false)
    private readonly hasHadFocus_new: KnockoutObservable<boolean> = ko.observable(false)
    private readonly hasHadFocus_repeat: KnockoutObservable<boolean> = ko.observable(false)
    private readonly isGenerating: KnockoutObservable<boolean>
    private readonly onSubmitClick: Function
    private readonly passwordpolicy: IPasswordPolicy
    private readonly mode: TPasswordPageMode
    private readonly changepasswordrequiresoldpassword: boolean;
    private readonly showSubmitButton: boolean

    constructor(params: IParams) {
        this.observableInputs = params.observableInputs
        this.formValidator = params.formValidator
        this.onSubmitClick = params.onSubmitClick
        this.passwordpolicy = params.passwordpolicy
        this.isGenerating = params.isGenerating
        this.mode = params.mode
        this.showSubmitButton = params.showSubmitButton !== false
        this.changepasswordrequiresoldpassword = this.mode === 'own'
            && nsResetPassword.get_changepasswordrequiresoldpassword()
        this.states = {
            old: () => {
                const isValid: boolean = this.formValidator.isOldValid()
                if (isValid) {
                    return null
                } else {
                    return 'warning'
                }
            },
            new: () => {
                const hasHadFocus = this.hasHadFocus_new() && this.hasHadFocus_repeat()
                if (!hasHadFocus) {
                    return null
                }
                const isValid: boolean = this.formValidator.isNewValid()
                if (isValid) {
                    return null
                } else {
                    return 'warning'
                }
            },
            repeat: () => {
                const hasHadFocus = this.hasHadFocus_new() && this.hasHadFocus_repeat()
                if (!hasHadFocus) {
                    return null
                }
                const isSame: boolean = this.formValidator.isRepeatValid()
                if (isSame) {
                    return null
                } else {
                    return 'warning'
                }
            },
        }

    }

}